export enum ModuleId {
  Documents = 'DocumentsModule',
  SSUDocuments = 'SSUDocumentsModule',
  StartupDocuments = 'StartupDocumentsModule',
  EtmfSitesModuleId = 'EtmfSitesModule',
  EtmfSitesQmsModuleId = 'EtmfSitesModule-qms',
  EtmfCountryCodingSitesModuleId = 'ETMFCountryCodingSites',
  EtmfCountryDetailsSitesModuleId = 'ETMFCountryDetailsSites',
}
